export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-thumbnail-480-eb9942d58deb93282718837e9b5a6712.webp";